import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';

export default function Page21({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<RoundScreen
				title='Exercise 06 Triceps'
				rounds={[
					[
						{
							header: 'Exercise',
							value: 'Skull Crushes',
						},
						{
							header: '# of sets',
							value: '1',
						},
						{
							header: 'REPS / Weight',
							value: '6 - 10 Light - Mild',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Warm - Up, Targeting all 3 Heads',
						},
					],
					[
						{
							header: 'Exercise',
							value: 'Skull Crushes',
						},
						{
							header: '# of sets',
							value: '2 - 3',
						},
						{
							header: 'REPS / Weight',
							value: '6 - 10 Mild',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Working Set, Controlled / Focus',
						},
					],
					[
						{
							header: 'Exercise',
							value: 'Skull Crushes',
						},
						{
							header: '# of sets',
							value: '4',
						},
						{
							header: 'REPS / Weight',
							value: 'Mild',
						},
						{
							header: 'MINDSET/ FOCUSES INSTRUCTIONS',
							value: 'Full On Set Till Failure (Burn - Out)',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
